import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FwButtonModule, FwIconModule, FwLayoutsModule } from '@flywheel-io/vision';

import { PipesModule } from '../shared/pipes.module';
import { LoginErrorComponent } from './login-error.component';
import { SessionTimeoutErrorComponent } from './session-timeout-error.component';
import { UserSyncErrorComponent } from './user-sync-error.component';

@NgModule({
  imports: [CommonModule, FwButtonModule, FwIconModule, FwLayoutsModule, PipesModule],
  declarations: [LoginErrorComponent, UserSyncErrorComponent, SessionTimeoutErrorComponent],
})
export class FatalErrorsModule {}
